/* eslint-disable @typescript-eslint/restrict-template-expressions */
import React from 'react';
import {Divider} from '@wix/wix-ui-tpa';
import {ShippingSection} from '../ShippingSection/ShippingSection';
import {TotalsSection} from '../TotalsSection/TotalsSection';
import s from './Layout.scss';
import {ProductLineItems} from '../ProductLineItemsSection/ProductLineItems';
import {useControllerProps} from '../../ControllerContext';
import {shouldShowBilling, shouldShowShipping} from './utils';
import {useSlotPlaceholder} from '@wix/widget-plugins-ooi';
import {SlotsKey, SlotsKeyType} from '../../../constants';

export enum LayoutDataHook {
  root = 'LayoutDataHook.root',
  itemsSection = 'LayoutDataHook.itemsSection',
  totalsSection = 'LayoutDataHook.totalsSection',
  shippingSection = 'LayoutDataHook.shippingSection',
  productLineItem = 'LayoutDataHook.productLineItem',
  calendarIcon = 'LayoutDataHook.calendarIcon',
  slotDetailsBefore = 'LayoutDataHook.slotDetailsBefore',
  slotDetailsAfter = 'LayoutDataHook.slotDetailsAfter',
  slotItemsAfter = 'LayoutDataHook.slotItemsAfter',
}

export const Layout = () => {
  const {
    billingAddress,
    address: shippingAddress,
    totalPrice,
    pickupAddress,
    isPickupSelected,
    isHavePayments,
    shouldShowSlotBeforeItems,
  } = useControllerProps().thankYouPageStore;

  // @ts-expect-error: titk@wix.com - Suppress for regression on making TS config stricter. Fix please if you touch this code 🙏
  const showBilling = shouldShowBilling({billingAddress, totalPrice});
  const showShipping = shouldShowShipping({isPickupSelected, pickupAddress, shippingAddress});

  return (
    <div className={s.root} data-hook={LayoutDataHook.root}>
      {shouldShowSlotBeforeItems && (
        <Slot dataHook={LayoutDataHook.slotDetailsBefore} slotKey={SlotsKey.DetailsBefore} />
      )}

      <div className={s.box}>
        <Divider className={s.divider} />
        <section className={s.lineItemsSection} data-hook={LayoutDataHook.itemsSection}>
          <ProductLineItems />
        </section>
        <Divider className={s.divider} />
        <section className={s.totalsSection} data-hook={LayoutDataHook.totalsSection}>
          <TotalsSection />
        </section>
      </div>

      {shouldShowSlotBeforeItems && <Slot dataHook={LayoutDataHook.slotItemsAfter} slotKey={SlotsKey.ItemsAfter} />}

      {(isHavePayments || showShipping || showBilling) && (
        <div className={`${s.box} ${s.shippingBox}`}>
          <section className={s.shippingSection} data-hook={LayoutDataHook.shippingSection}>
            <ShippingSection />
          </section>
        </div>
      )}

      {shouldShowSlotBeforeItems && <Slot dataHook={LayoutDataHook.slotDetailsAfter} slotKey={SlotsKey.DetailsAfter} />}
    </div>
  );
};

function Slot({dataHook, slotKey}: {dataHook: string; slotKey: SlotsKeyType}) {
  const [SlotComponent, isEmpty] = useSlotPlaceholder(slotKey);

  if (isEmpty) {
    return null;
  }

  return (
    <div data-hook={dataHook} className={s.boxMarginBotton}>
      <SlotComponent />
    </div>
  );
}
